import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { BannersItems, GetBannersParams, BannerTypes, CreateBannerPayload } from '@models'

@Injectable({ providedIn: 'root' })
export class BannerService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/banners`

  constructor(private http: HttpClient) {}

  async getAll(params: GetBannersParams): Promise<BannersItems> {
    let httpParams = new HttpParams().set('page', params.page.toString()).set('pageSize', params.pageSize.toString())

    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)
    if (params.order) httpParams = httpParams.set('order', params.order)
    if (params.status) httpParams = httpParams.set('status', params.status)
    if (params.text) httpParams = httpParams.set('text', params.text)
    if (params.bannerType) httpParams = httpParams.set('bannerType', params.bannerType)

    const response = await firstValueFrom(this.http.get<BannersItems>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<BannerTypes> {
    const response = await firstValueFrom(this.http.get<BannerTypes>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: CreateBannerPayload): Promise<BannerTypes> {
    const response = await firstValueFrom(this.http.post<BannerTypes>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: CreateBannerPayload): Promise<BannerTypes> {
    const response = await firstValueFrom(this.http.put<BannerTypes>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
